<header *ngIf="authenticationService.IsAuthenticated()">
  <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" aria-label="Fifth navbar example">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"> <img src="../assets/Text700x400.png" width="110px"></a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample05"
        aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarsExample05">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" [routerLink]="['/Dashboard']">Inicio</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-bs-toggle="dropdown"
              aria-expanded="false">Mantenimiento</a>
            <ul class="dropdown-menu" aria-labelledby="dropdown05">
              <li><a [routerLink]="['/Discount']" class="dropdown-item" href="#">Descuentos</a></li>
              <li><a [routerLink]="['/Branch']" class="dropdown-item" href="#">Sucursales</a></li>
              <li><a [routerLink]="['/Tax']" class="dropdown-item" href="#">Impuestos</a></li>
              <li><a [routerLink]="['/Warehouse']" class="dropdown-item" href="#">Bodegas</a></li>
              <li><a [routerLink]="['/Provider']" class="dropdown-item" href="#">Proveedores</a></li>
              <li><a [routerLink]="['/Source']" class="dropdown-item" href="#">Locaciones</a></li>
              <li><a [routerLink]="['/Customer']" class="dropdown-item" href="#">Clientes</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a [routerLink]="['/Category']" class="dropdown-item" href="#">Categorias</a></li>
              <li><a [routerLink]="['/SubCategory']" class="dropdown-item" href="#">Sub Categorias</a></li>
              <li><a [routerLink]="['/Product']" class="dropdown-item" href="#">Productos</a></li>
              <li><a [routerLink]="['/Item']" class="dropdown-item" href="#">Articulos</a></li>
              <li><a [routerLink]="['/ProductDetail']" class="dropdown-item" href="#">Productos det.</a></li>
              <li><a [routerLink]="['/Bundle']" class="dropdown-item" href="#">Paquetes/Combos</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-bs-toggle="dropdown"
              aria-expanded="false">Procesos</a>
            <ul class="dropdown-menu" aria-labelledby="dropdown05">
              <li><a [routerLink]="['/Orders']" class="dropdown-item" href="#">Facturacion</a></li>
              <li><a [routerLink]="['/Delivery']" class="dropdown-item" href="#">Despacho</a></li>
              <li><a [routerLink]="['/Tax']" class="dropdown-item" href="#">Cierre de Caja</a></li>
              <li><a [routerLink]="['/Warehouse']" class="dropdown-item" href="#">Mov. Inventario</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-bs-toggle="dropdown"
              aria-expanded="false">Herramientas</a>
            <ul class="dropdown-menu" aria-labelledby="dropdown05">
              <li><a [routerLink]="['/Client']" class="dropdown-item" href="#">Configuracion</a></li>
              <li><a [routerLink]="['/Settings']" class="dropdown-item" href="#">Configuracion</a></li>
              <li><a [routerLink]="['/User']" class="dropdown-item" href="#">Usuarios</a></li>
              <li><a [routerLink]="['/Payments']" class="dropdown-item" href="#">Pagos</a></li>
              <li><a [routerLink]="['/Utilities']" class="dropdown-item" href="#">Utilidades</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Reportes</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link active dropdown-toggle" href="#" id="dropdown05" data-bs-toggle="dropdown"
              aria-expanded="false"><i class="fa fa-user" aria-hidden="true"></i></a>
            <ul class="dropdown-menu" aria-labelledby="dropdown05">
              <li><a class="dropdown-item" [routerLink]="['/Contact']" href="#">Contacto</a></li>
              <li><a class="dropdown-item" [routerLink]="['/Profile']" href="#">Mi perfil</a></li>
              <li><a class="dropdown-item" [routerLink]="['/Help']">Ayuda</a></li>
              <li><a class="dropdown-item" (click)="onLogOut();">Salir</a></li>
            </ul>
          </li>
        </ul>
        <!-- <form>
          <input class="form-control" type="text" placeholder="Search" aria-label="Search">
        </form> -->
      </div>
    </div>
  </nav>
</header>
<main role="main" style="margin-top: 1%;">
  <router-outlet></router-outlet>
</main>
<p-confirmDialog #cd header="Confirmacion" icon="pi pi-exclamation-triangle" key="main">
  <p-footer>
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-primary fixedButton" label="Cancelar" (click)="cd.accept()">Salir</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-secondary fixedButton" label="Salir"
          (click)="cd.reject()">Cancelar</button>
      </div>
    </div>
  </p-footer>
</p-confirmDialog>